import { Link } from 'react-router-dom';
import { NotesThread } from '../notes/NotesThread';

/**
 * "My notes" tab: everything the person writes about their time with this
 * organisation, in one place — their own notes on it, on each place they
 * lived under it, and on the people named there. Sealed with their key; it
 * sits beside the records and never changes them. Notes on a single record
 * or a highlight live on that record.
 */
export const OrgNotes = ({ org }) => {
  const placements = (org.placements || []).filter((p) => p.id);
  const people = (org.social_workers || []).filter((p) => p.name);
  return (
    <div className="space-y-8" data-testid="org-notes">
      <section className="rounded-lg bg-ground p-5">
        <NotesThread
          kind="memory" targetType="organisation" targetId={org.id} orgId={org.id}
          heading="My notes"
          prompt={`Anything about your time with ${org.name} — people, places, what it was like, what the records get wrong. Only you, and anyone you choose to share with, can read it.`}
          placeholder="Write as much or as little as you like…"
          testId="org-my-notes"
        />
      </section>

      {placements.length > 0 && (
        <section className="space-y-3">
          <h2 className="font-heading text-[20px] font-semibold tracking-[-0.02em] text-ink">Places you lived</h2>
          {placements.map((p) => (
            <div key={p.id} className="rounded-lg bg-ground p-5 space-y-2">
              <Link to={`/organisations/${org.id}/placements/${p.id}`} className="text-sm font-semibold text-brand hover:text-brand-ink">
                View this placement
              </Link>
              <NotesThread
                kind="memory" targetType="placement" targetId={p.id} orgId={org.id} compact
                heading={p.name || (p.carer_names?.length ? p.carer_names.join(' and ') : 'A placement')}
                prompt="The house, the people, a routine, how it felt."
                testId={`placement-notes-${p.id}`}
              />
            </div>
          ))}
        </section>
      )}

      {people.length > 0 && (
        <section className="space-y-3">
          <h2 className="font-heading text-[20px] font-semibold tracking-[-0.02em] text-ink">People</h2>
          {people.map((p, i) => (
            <div key={`${p.name}-${i}`} className="rounded-lg bg-ground p-5">
              <NotesThread
                targetType="person" personName={p.name} orgId={org.id} compact
                heading={p.name}
                prompt="What they were like, what you remember of them, or anything the records get wrong about them."
                testId={`person-notes-${i}`}
              />
            </div>
          ))}
        </section>
      )}
    </div>
  );
};

export default OrgNotes;
